import { Popover, MenuList, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import Input from '@material-ui/core/Input'
import { injectIntl } from 'react-intl'
import MenuItem from 'components/override/MaterialUI/MenuItem'
import { ASSIGNED, USERS, USER_GROUP } from 'constants/index'
import messages from 'components/common/Inputs/translate'
import translate from './translate'

function MultiSelect({
  options = {},
  selected = [],
  setSelected,
  buttonRef,
  handleClose,
  hasSelectAllOption = false,
  disabled,
  isSiteList,
  allSelectedSites,
  intl: { formatMessage },
}) {
  const [searchValue, setSearchValue] = useState('')
  const getFilteredList = list =>
    (list || []).filter(
      option =>
        option &&
        option.name &&
        option.name.toUpperCase().includes(searchValue.toUpperCase()) &&
        (!isSiteList || !(allSelectedSites || []).includes(option.id)),
    )
  let groups
  let users
  let allOptions
  const selectedList = getFilteredList(selected)

  if (!isSiteList) {
    groups = getFilteredList(options.groupList)
    users = getFilteredList(options.userList).map(user => ({
      ...user,
      isUser: true,
    }))
    allOptions = [
      { isLabel: true, title: ASSIGNED },
      ...selectedList,
      { isLabel: true, title: USER_GROUP },
      ...groups.filter(({ id }) => !selected.find(item => item?.id === id)),
      { isLabel: true, title: USERS },
      ...users.filter(({ id }) => !selected.find(item => item?.id === id)),
    ]
  } else {
    allOptions = getFilteredList(options)
  }

  const allFilteredOptions = allOptions.filter(option => option.id != null)
  const allSitesOption = {
    id: null,
    name: formatMessage(translate.allSites),
  }
  const isAllSitesSelected = selected.some(item => item && item.id == null)

  const onChangeSelectAll = () => {
    if (isSiteList) {
      setSelected(isAllSitesSelected ? [] : [allSitesOption])

      return
    }

    const allSelected = selected?.length === allFilteredOptions?.length
    setSelected(allSelected ? [] : allFilteredOptions)
  }

  const renderSelectAllOption = () => {
    const allSelected = isSiteList
      ? isAllSitesSelected
      : selected?.length === allFilteredOptions?.length

    return (
      <MenuItem
        key="select_all"
        value="SELECT_ALL"
        selected={allSelected}
        isPurpleStyle
        onClick={() => {
          onChangeSelectAll()
        }}>
        {formatMessage(isSiteList ? translate.allSites : messages.selectAll)}
      </MenuItem>
    )
  }

  const isSelected = id => !!selected.find(item => item?.id === id)

  const getLabel = label => {
    if (label === ASSIGNED) {
      return selectedList.length ? (
        <Typography key={label} variant="subtitle1" className="subtitle">
          {formatMessage(translate.assigned)}
        </Typography>
      ) : null
    }

    if (label === USER_GROUP) {
      return groups.length ? (
        <Typography key={label} variant="subtitle1" className="subtitle">
          {formatMessage(translate.userGroup)}
        </Typography>
      ) : null
    }

    if (label === USERS) {
      return users.length ? (
        <Typography key={label} variant="subtitle1" className="subtitle">
          {formatMessage(translate.users)}
        </Typography>
      ) : null
    }

    return null
  }

  return (
    <Popover
      open={!!buttonRef && !disabled}
      anchorEl={buttonRef}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}>
      <div className="multi-select">
        <div className="search-block">
          <Input
            className="search-field"
            placeholder={
              isSiteList
                ? formatMessage(translate.searchBySite)
                : formatMessage(translate.searchByUser)
            }
            onChange={({ target: { value } }) => setSearchValue(value)}
            value={searchValue}
            disableUnderline
          />
        </div>
        <MenuList className="option-list">
          {hasSelectAllOption && renderSelectAllOption()}
          {allOptions.map(({ isLabel, name, id, title, isUser }) =>
            isLabel ? (
              getLabel(title)
            ) : (
              <MenuItem
                key={`${id}${name}`}
                value={id}
                selected={isSelected(id)}
                isPurpleStyle
                onClick={() => {
                  if (isSelected(id)) {
                    setSelected(selected.filter(item => item?.id !== id))

                    return
                  }

                  if (isSiteList) {
                    setSelected([
                      ...selected.filter(item => item && item.id != null),
                      { id, name, isUser },
                    ])

                    return
                  }

                  setSelected([...selected, { id, name, isUser }])
                }}>
                {name}
              </MenuItem>
            ),
          )}
        </MenuList>
      </div>
    </Popover>
  )
}

export default injectIntl(MultiSelect)
